import { render, staticRenderFns } from "./salemanRoleConfig.vue?vue&type=template&id=37295602&scoped=true"
import script from "./salemanRoleConfig.vue?vue&type=script&lang=js"
export * from "./salemanRoleConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37295602",
  null
  
)

export default component.exports